module.exports = __webpack_public_path__ + "img/octagon-exclamation.2caaf7fa.svg";